import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Склейка классов: последний конфликтующий класс Tailwind побеждает. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
